import React from 'react';
import { Helmet } from 'react-helmet-async';

import type { SEO } from '@swf/cms';

export interface DyanmicSEOProperties {
  canonical: string;
  alternates: { hreflang: string; href: string }[];
}

const CMSSEO: React.FC<SEO & DyanmicSEOProperties> = ({
  meta: { title, description, keywords },
  canonical,
  alternates
}) =>
  title || description || keywords || canonical || alternates ? (
    <Helmet>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}
    </Helmet>
  ) : null;
export default CMSSEO;
